export var FileV2Status;

(function (FileV2Status) {
  FileV2Status[FileV2Status["Pending"] = 1] = "Pending";
  FileV2Status[FileV2Status["Active"] = 2] = "Active";
  FileV2Status[FileV2Status["Deleted"] = 3] = "Deleted";
})(FileV2Status || (FileV2Status = {}));